import { ColDef, ColGroupDef } from '@ag-grid-community/core';
import { Component, Input, OnChanges } from '@angular/core';
import { AgGridHelperService } from '../services/ag-grid-helper.service';
import { PpssCard } from '../ppss-card/ppss-card.component';
import { ProductData } from '@types';

// import { Logger } from '@utils/logger';
// const logger = Logger.getLogger('PpssCardContainerComponent');

@Component({
  selector: 'ft-ppss-card-container',
  templateUrl: './ppss-card-container.component.html',
  styleUrls: ['./ppss-card-container.component.scss'],
})
export class PpssCardContainerComponent implements OnChanges {
  @Input() rowData: ProductData[];
  @Input() columnDefs: (ColDef | ColGroupDef)[];
  @Input() gridContext: any;
  @Input() isSiteIntl: boolean;
  public cardData: PpssCard[];

  constructor(private helperService: AgGridHelperService) {}

  ngOnChanges() {
    this.refresh();
  }

  refresh(): void {
    if (this.rowData && this.columnDefs && this.columnDefs.length > 0) {
      this.cardData = this.rowData.map(
        (fund: ProductData): PpssCard =>
          this.helperService.getPpssCardData(
            this.columnDefs,
            fund,
            this.gridContext,
            this.isSiteIntl
          )
      );

      // Sort card data on Fav funds, so that favorited funds are dispalyed first
      this.cardData.sort((a, b) => {
        const isFavFundA = a.isFavoriteFund;
        const isFavFundB = b.isFavoriteFund;
        return isFavFundB === isFavFundA ? 0 : isFavFundA ? -1 : 1;
      });
    }
  }

  trackCards(index: number, card: PpssCard): string {
    // this is used to stop cards redrawing every time something changes
    return card.cardId;
  }
}
